"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrintableTurnRightIcon = PrintableTurnRightIcon;
var _renderer = require("@react-pdf/renderer");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function PrintableTurnRightIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_renderer.Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement(_renderer.Path, {
    d: "M12 0c-6.616 0-12 5.385-12 12.002s5.383 11.998 12 11.998 12-5.382 12-11.998-5.384-12.002-12-12.002zM12 22.92c-1.245 0-2.438-0.219-3.552-0.604 0.009-0.041 0.025-0.081 0.025-0.125v-9.232c0-0.102 0.029-2.51 2.471-2.51h7.909l-3.955 3.956c-0.219 0.219-0.22 0.578-0.001 0.795 0.11 0.11 0.255 0.165 0.399 0.165s0.288-0.054 0.398-0.164l4.917-4.915c0.107-0.105 0.165-0.249 0.165-0.399s-0.058-0.293-0.163-0.399l-4.917-4.917c-0.219-0.219-0.577-0.219-0.796 0s-0.219 0.578 0 0.796l3.958 3.957h-7.913c-2.844 0-3.595 2.377-3.595 3.635v8.907c-3.699-1.752-6.269-5.509-6.269-9.864 0-6.022 4.899-10.92 10.92-10.92s10.92 4.899 10.92 10.92c0 6.021-4.898 10.918-10.92 10.918z",
    fill: color
  }));
}